import { useParams } from "react-router-dom";
import ReportPreviewView from "./preview/ReportPreviewView";

const ReportPreviewPage = () => {
  const {
    clientNameParam,
    propertyMasterId,
    inspectionRefnumber,
  } = useParams();

  return (
    <ReportPreviewView
      clientNameParam={clientNameParam}
      propertyMasterId={propertyMasterId}
      inspectionReferenceNumber={inspectionRefnumber}
    />
  );
};

export default ReportPreviewPage;
